import React from 'react'

export default function WriteManage() {
  return <div>撰写管理</div>
}
